import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect, useRef } from "react";
import { Grid, LibraryAddIcon, MouseOverPopover, Tabs, AcademyCourseLanguage, arrLanguages, AcademyCourseInfo, Dialog, DialogCourseLanguageInfo, DialogCourseAddLanguage, DialogCourseEditCategory, DialogCourseEditTags, translate, convertToRaw, FileUpload, Alert, server, EditorState, convertFromRaw, draftToHtml, Button } from "../../../../../";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import PhotoLibraryIcon from "@material-ui/icons/PhotoLibrary";
import { Prompt } from "react-router-dom";
import { Typography, Tooltip } from "@material-ui/core";
import { Link } from "react-router-dom";

var AcademyCoursesSingle = function AcademyCoursesSingle(props) {
  var _useState = useState("es"),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      alert = _useState4[0],
      setAlert = _useState4[1];

  var _useState5 = useState({
    open: false
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      alertS3 = _useState6[0],
      setAlertS3 = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      openHandleEditCategory = _useState8[0],
      setOpenHandleEditCategory = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      openHandleEditTags = _useState10[0],
      setOpenHandleEditTags = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      openHandleAddLanguage = _useState12[0],
      setOpenHandleAddLanguage = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      openHandleDeleteLanguage = _useState14[0],
      setOpenHandleDeleteLanguage = _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      openHandleEditLanguage = _useState16[0],
      setOpenHandleEditLanguage = _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      openHandleRestartCourse = _useState18[0],
      setOpenHandleRestartCourse = _useState18[1];

  var _useState19 = useState(false),
      _useState20 = _slicedToArray(_useState19, 2),
      openHandleChangeStatusCourse = _useState20[0],
      setOpenHandleChangeStatusCourse = _useState20[1];

  var _useState21 = useState(false),
      _useState22 = _slicedToArray(_useState21, 2),
      openHandleEditCourse = _useState22[0],
      setOpenHandleEditCourse = _useState22[1];

  var _useState23 = useState(false),
      _useState24 = _slicedToArray(_useState23, 2),
      openHandleDeleteCourse = _useState24[0],
      setOpenHandleDeleteCourse = _useState24[1];

  var _useState25 = useState(null),
      _useState26 = _slicedToArray(_useState25, 2),
      languageToDelete = _useState26[0],
      setLanguageToDelete = _useState26[1];

  var _useState27 = useState(null),
      _useState28 = _slicedToArray(_useState27, 2),
      languageToEdit = _useState28[0],
      setLanguageToEdit = _useState28[1];

  var _useState29 = useState(null),
      _useState30 = _slicedToArray(_useState29, 2),
      statusCourseToChange = _useState30[0],
      setStatusCourseToChange = _useState30[1];

  var categories = [{
    label: "Tech",
    value: "tech"
  }, {
    label: "Product",
    value: "product"
  }, {
    label: "Marketing",
    value: "marketing"
  } // { label: "Ideas", value: "ideas" }
  ]; // HANDLE OPEN S3

  var handleCloseAlertS3 = function handleCloseAlertS3() {
    setAlertS3({
      open: false
    });
  }; // HANDLE ALERT S3


  var handleAlertS3 = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(variant, values) {
      var clipboard;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = variant;
              _context.next = _context.t0 === "success" ? 3 : _context.t0 === "error" ? 9 : 11;
              break;

            case 3:
              // console.log("values success s3 upload", values);
              navigator.clipboard.writeText(values.publicUrl);
              _context.next = 6;
              return navigator.clipboard.readText();

            case 6:
              clipboard = _context.sent;
              setAlertS3({
                open: true,
                title: "Image uploaded",
                status: "success",
                text: clipboard ? /*#__PURE__*/React.createElement(Typography, {
                  variant: "body1"
                }, "URL coppied to clipboard") : [/*#__PURE__*/React.createElement(Typography, {
                  variant: "body1"
                }, "This is the url"), /*#__PURE__*/React.createElement(Typography, {
                  variant: "body2"
                }, values.publicUrl)],
                submit: "Close",
                onSubmit: handleCloseAlertS3,
                onClose: handleCloseAlertS3
              });
              return _context.abrupt("break", 12);

            case 9:
              // console.log("values error s3 upload", values);
              setAlertS3({
                open: true,
                title: "Image not uploaded",
                status: "error",
                text: "Take values",
                submit: "Close",
                onSubmit: handleCloseAlertS3,
                onClose: handleCloseAlertS3
              });
              return _context.abrupt("break", 12);

            case 11:
              return _context.abrupt("break", 12);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleAlertS3(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(); // HANDLE ADD LANGUAGE


  var handleAddLanguage = function handleAddLanguage(values) {
    var languageDefault = _objectSpread(_objectSpread({}, props.languages["es"]), {}, {
      editorState: convertToRaw(props.languages["es"].editorState.getCurrentContent()),
      status: "draft",
      reviewed: false
    }); // console.log("state", languageDefault);


    Promise.all(Object.keys(values).filter(function (value) {
      return values[value] === true;
    }).map(function (value) {
      // console.log("values handle add language value", value);
      // console.log("language", languageDefault);
      // const state = languageDefault.editorState;
      var editorStateModified = _objectSpread({}, languageDefault.editorState);

      return Promise.all(editorStateModified.blocks.map(function (block) {
        if (block.text !== "") return translate(block.text, "es", value).then(function (text_translated) {
          return _objectSpread(_objectSpread({}, block), {}, {
            text: text_translated
          });
        });else {
          return _objectSpread({}, block);
        }
      })).then(function (newState) {
        // console.log("final value", newState);
        // console.log("value editorState", editorStateModified);
        return translate(languageDefault.name, "es", value).then(function (name_translated) {
          return translate(languageDefault.description, "es", value).then(function (description_translated) {
            var editorStateLanguage = _objectSpread(_objectSpread({}, editorStateModified), {}, {
              blocks: newState
            }); // console.log(
            //   "value editorStateLanguage",
            //   editorStateLanguage
            // );


            return _objectSpread(_objectSpread({}, languageDefault), {}, {
              name: name_translated,
              description: description_translated,
              lang: value,
              editorState: editorStateLanguage
            });
          });
        });
      });
    })).then(function (x) {
      // console.log("final array", x);
      var languages = {};
      x.forEach(function (language) {
        languages[language.lang] = _objectSpread({}, language);
        delete languages[language.lang].lang;
      });
      props.handleAddLanguage(languages);
    });
  }; // MODAL EDIT CATEGORY


  var handleModalEditCategory = function handleModalEditCategory() {
    // console.log("handle button Modal edit category clicked");
    setOpenHandleEditCategory(!openHandleEditCategory);
  }; // MODAL EDIT Tags


  var handleModalEditTags = function handleModalEditTags() {
    // console.log("handle button Modal edit tags clicked");
    setOpenHandleEditTags(!openHandleEditTags);
  }; // MODAL ADD LANGUAGE


  var handleModalAddLanguage = function handleModalAddLanguage() {
    // console.log("handle button Modal language clicked");
    setOpenHandleAddLanguage(!openHandleAddLanguage);
  }; // MODAL DELETE LANGUAGE


  var handleModalDeleteLanguage = function handleModalDeleteLanguage(language) {
    // console.log("handle delete language clicked", language);
    // Close modal
    if (openHandleDeleteLanguage) {
      setLanguageToDelete(null);
    } // Open modal
    else {
        setLanguageToDelete(language);
      }

    setOpenHandleDeleteLanguage(!openHandleDeleteLanguage);
  }; // MODAL EDIT LANGUAGE


  var handleModalEditLanguage = function handleModalEditLanguage(language) {
    // console.log("handle edit language clicked", language);
    // Close modal
    if (openHandleEditLanguage) {
      setLanguageToEdit(null);
    } // Open modal
    else {
        setLanguageToEdit(language);
      }

    setOpenHandleEditLanguage(!openHandleEditLanguage);
  }; // MODAL RESTART COURSE


  var handleModalRestartCourse = function handleModalRestartCourse() {
    // console.log("handle restart course clicked");
    setOpenHandleRestartCourse(!openHandleRestartCourse);
  }; // MODAL CHANGE STATUS COURSE


  var handleModalChangeStatusCourse = function handleModalChangeStatusCourse(prevStatus) {
    // console.log("handle change status course clicked", prevStatus);
    var status = "";

    switch (prevStatus) {
      case "building":
        status = "draft";
        break;

      case "draft":
        status = "published";
        break;

      case "published":
        status = "draft";
        break;

      default:
        console.log("err parameter", prevStatus);
        break;
    } // OPEN MODAL


    if (status !== "") {
      setStatusCourseToChange(status);
      setOpenHandleChangeStatusCourse(!openHandleChangeStatusCourse);
    } // CLOSE MODAL
    else {
        setOpenHandleChangeStatusCourse(!openHandleChangeStatusCourse);
        setStatusCourseToChange(props.status);
      }
  }; // MODAL RESTART COURSE


  var handleModalEditCourse = function handleModalEditCourse() {
    // console.log("handle edit course clicked");
    setOpenHandleEditCourse(!openHandleEditCourse);
  }; // MODAL DELETE COURSE


  var handleModalDeleteCourse = function handleModalDeleteCourse() {
    // console.log("handle delete course clicked");
    setOpenHandleDeleteCourse(!openHandleDeleteCourse);
  };

  var handleChangeStatusLanguage = function handleChangeStatusLanguage(language, prevStatus) {
    var status = "";

    switch (prevStatus) {
      case "draft":
        status = "published";
        break;

      case "published":
        status = "draft";
        break;

      default:
        break;
    }

    if (status !== "") props.handleChangeStatusLanguage(language, status);else console.log("error prevStatus", prevStatus);
  }; // FUNCTIONS TAB


  var handleTabs = function handleTabs(event, newValue) {
    setValue(newValue);
  };

  var handleEditorChangeLanguage = function handleEditorChangeLanguage(content, html) {
    props.handleEditorChange(content, html, value);
  };

  var contentTabHandler = function contentTabHandler(tab) {
    var auxTab = "";
    props.languages && Object.keys(props.languages).forEach(function (language) {
      if (language === tab) {
        auxTab = language;
      }
    }); // tab is info

    if (auxTab === "") {
      return /*#__PURE__*/React.createElement(AcademyCourseInfo, {
        languages: props.languages,
        status: props.status,
        visible: props.visible,
        category: props.category,
        tags: props.tags,
        handleModalEditCategory: handleModalEditCategory,
        handleModalEditTags: handleModalEditTags,
        handleModalAddLanguage: handleModalAddLanguage,
        handleModalRestartCourse: handleModalRestartCourse,
        handleModalChangeStatusCourse: handleModalChangeStatusCourse,
        handleModalEditCourse: handleModalEditCourse,
        handleModalDeleteCourse: handleModalDeleteCourse
      });
    } //tab is language


    if (props.languages[auxTab].downloaded) {
      return /*#__PURE__*/React.createElement(AcademyCourseLanguage, {
        language: props.languages[auxTab],
        tab: auxTab,
        handleEditorChangeLanguage: handleEditorChangeLanguage,
        handleSaveLanguage: props.handleSaveLanguage,
        handleReviewLanguage: props.handleReviewLanguage,
        handleModalDeleteLanguage: handleModalDeleteLanguage,
        handleModalEditLanguage: handleModalEditLanguage,
        handleChangeStatusLanguage: handleChangeStatusLanguage,
        idCourse: props.idCourse
      });
    } else {
      props.downloadLanguage(auxTab);
      return null;
    }
  }; // CONTROL WEB ALERT


  var shouldBlockNavigation = useRef();
  useEffect(function () {
    checkSavedLanguages();

    if (shouldBlockNavigation && alert) {
      window.onbeforeunload = function () {
        return true;
      };
    } else {
      window.onbeforeunload = undefined;
    }
  });

  var checkSavedLanguages = function checkSavedLanguages() {
    var checked = props.languages ? Object.keys(props.languages).find(function (language) {
      return props.languages[language].saved === false;
    }) : undefined; // console.log("check language", checked);

    setAlert(checked === undefined ? false : true);
  };

  return /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Prompt, {
    when: alert,
    message: "You have changes without save, do you want to continue?"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Alert, alertS3), /*#__PURE__*/React.createElement(DialogCourseEditCategory, {
    categories: categories,
    data: {
      category: props.category
    },
    open: openHandleEditCategory,
    onClose: handleModalEditCategory,
    onSubmit: props.handleSubmitEditCategory
  }), /*#__PURE__*/React.createElement(DialogCourseEditTags, {
    tags: props.tags,
    data: props.tags.map(function (tag) {
      return {
        label: tag,
        value: tag
      };
    }),
    open: openHandleEditTags,
    onClose: handleModalEditTags,
    onSubmit: props.handleSubmitEditTags
  }), /*#__PURE__*/React.createElement(DialogCourseAddLanguage, {
    open: openHandleAddLanguage,
    onClose: handleModalAddLanguage,
    languages: props.languages && Object.keys(props.languages).map(function (_key) {
      return _key;
    }),
    onSubmit: handleAddLanguage
  }), /*#__PURE__*/React.createElement(Dialog, {
    open: openHandleDeleteLanguage,
    onClose: handleModalDeleteLanguage,
    title: "Do you want to remove this language?",
    text: "You will lose all content from this language",
    submit: "Delete",
    buttonColorSubmit: "secondary",
    buttonVariantSubmit: "contained",
    onCancel: handleModalDeleteLanguage,
    cancel: "Cancel",
    buttonColorCancel: "secondary",
    buttonVariantCancel: "outlined",
    onSubmit: function onSubmit() {
      setValue("es");
      handleModalDeleteLanguage();
      props.handleDeleteLanguage(languageToDelete);
    }
  }), /*#__PURE__*/React.createElement(DialogCourseLanguageInfo, {
    open: openHandleEditLanguage,
    onClose: handleModalEditLanguage,
    data: languageToEdit && {
      name: props.languages[languageToEdit].name,
      description: props.languages[languageToEdit].description
    },
    onSubmit: function onSubmit(values) {
      return props.handleEditLanguage(values, languageToEdit);
    }
  }), /*#__PURE__*/React.createElement(Dialog, {
    open: openHandleChangeStatusCourse,
    onClose: handleModalChangeStatusCourse,
    title: "Confirm status course",
    text: "Do you want to change the status of this course to '" + statusCourseToChange + "'?",
    submit: "Confirm",
    buttonColorSubmit: "primary",
    buttonVariantSubmit: "outlined",
    onCancel: handleModalChangeStatusCourse,
    cancel: "Cancel",
    buttonColorCancel: "secondary",
    buttonVariantCancel: "outlined",
    onSubmit: function onSubmit() {
      handleModalChangeStatusCourse();
      props.handleChangeStatusCourse(statusCourseToChange);
    }
  }), /*#__PURE__*/React.createElement(Dialog, {
    open: openHandleRestartCourse,
    onClose: handleModalRestartCourse,
    title: "Do you want to restart this course?",
    text: "All languages but Spanish will be removed",
    submit: "Restart",
    buttonColorSubmit: "secondary",
    buttonVariantSubmit: "contained",
    onCancel: handleModalRestartCourse,
    cancel: "Cancel",
    buttonColorCancel: "secondary",
    buttonVariantCancel: "outlined",
    onSubmit: function onSubmit() {
      handleModalRestartCourse();
      props.handleRestartCourse();
    }
  }), /*#__PURE__*/React.createElement(Dialog, {
    open: openHandleDeleteCourse,
    onClose: handleModalDeleteCourse,
    title: "Do you want to delete this course?",
    text: "You will lose all content from this course",
    submit: "Delete",
    buttonColorSubmit: "secondary",
    buttonVariantSubmit: "contained",
    onCancel: handleModalDeleteCourse,
    cancel: "Cancel",
    buttonColorCancel: "secondary",
    buttonVariantCancel: "outlined",
    onSubmit: function onSubmit() {
      handleModalDeleteCourse();
      props.handleDeleteCourse();
    }
  })), props.languages && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 1
  }, /*#__PURE__*/React.createElement(Tooltip, {
    title: "Back to courses"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    color: "primary",
    component: Link,
    to: "/academy/courses"
  }, /*#__PURE__*/React.createElement(ArrowBackIcon, {
    color: "primary"
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 9
  }, /*#__PURE__*/React.createElement(Tabs, {
    value: value,
    onChange: handleTabs,
    variant: "scrollable" // className={classes.mb30}
    ,
    indicatorColor: "primary",
    textColor: "primary",
    contentTabs: [{
      label: "Info",
      value: "info"
    }].concat(_toConsumableArray(Object.keys(props.languages).map(function (language) {
      return arrLanguages.find(function (_language) {
        return _language.value === language;
      }) ? arrLanguages.find(function (_language) {
        return _language.value === language;
      }) : {
        label: "undefined" + language,
        value: language
      };
    })))
  })), value !== "info" && /*#__PURE__*/React.createElement(Grid, {
    xs: 2,
    style: {
      display: "flex",
      justifyContent: "flex-end"
    }
  }, /*#__PURE__*/React.createElement(FileUpload, {
    variant: "text",
    translation: {
      buttons: {
        upload: /*#__PURE__*/React.createElement(PhotoLibraryIcon, {
          color: "primary"
        })
      }
    },
    s3path: "academy/",
    onUploadError: function onUploadError(values) {
      return handleAlertS3("error", values);
    },
    onUploadFinish: function onUploadFinish(values) {
      return handleAlertS3("success", values);
    },
    server: props.server,
    accept: "image/*",
    signingUrl: "s3/sign",
    title: "Upload image"
  }), props.status === "building" ? null : value === "info" ? null : /*#__PURE__*/React.createElement(MouseOverPopover, {
    message: "Add new language"
  }, /*#__PURE__*/React.createElement(LibraryAddIcon, {
    style: {
      marginLeft: "16px",
      marginTop: "10px"
    },
    variant: "contained",
    color: "primary",
    onClick: handleModalAddLanguage
  })))), contentTabHandler(props.languages && value));
};

export { AcademyCoursesSingle };